'use strict';

angular.module('b2bLoginApp.services').factory('CompanySettingsService', ['$resource',
    function ($resource) {
        return {
            updateSettings: $resource('company-settings',
                {
                    companyId: '@companyId',
                    settingsId: '@settingsId',
                    receiveLeadEmails: '@receiveLeadEmails',
                },
                {save: {method: 'POST', isArray: true}}
            ),
        };
    }]);
